module.exports = __webpack_public_path__ + "img/gallery15.bb0d6d03.jpg";